import { useId } from 'react';

// Tiny close-price line for a Benchmark Comparison tile. Inline SVG so
// six of them mount for free; colour follows the period's direction.
export default function BenchmarkSparkline({ series, positive, testId }) {
  const gradId = useId();
  const pts = Array.isArray(series) ? series.filter((p) => Number.isFinite(Number(p?.c))) : [];
  if (pts.length < 2) return null;

  const W = 120;
  const H = 30;
  const PAD = 2;
  const closes = pts.map((p) => Number(p.c));
  const min = Math.min(...closes);
  const max = Math.max(...closes);
  const span = Math.max(1e-9, max - min);
  const xFor = (i) => PAD + (i / (pts.length - 1)) * (W - 2 * PAD);
  const yFor = (c) => H - PAD - ((c - min) / span) * (H - 2 * PAD);
  const line = closes.map((c, i) => `${xFor(i).toFixed(1)},${yFor(c).toFixed(1)}`).join(' ');
  const area = `${PAD},${H - PAD} ${line} ${(W - PAD).toFixed(1)},${H - PAD}`;
  const stroke = positive ? 'rgb(34 197 94)' : 'rgb(239 68 68)';

  const fmt = (d) => {
    const dt = new Date(d);
    return Number.isNaN(dt.getTime()) ? d : dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: '2-digit' });
  };
  const label = `${fmt(pts[0].d)} $${closes[0].toFixed(2)} → ${fmt(pts[pts.length - 1].d)} $${closes[closes.length - 1].toFixed(2)}`;

  return (
    <svg
      viewBox={`0 0 ${W} ${H}`}
      className="w-full h-7 mt-1.5 overflow-visible benchmark-sparkline"
      preserveAspectRatio="none"
      aria-label={`Price trend: ${label}`}
      data-testid={testId}
    >
      <title>{label}</title>
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={stroke} stopOpacity="0.28" />
          <stop offset="100%" stopColor={stroke} stopOpacity="0" />
        </linearGradient>
      </defs>
      <polygon points={area} fill={`url(#${gradId})`} />
      <polyline
        points={line}
        fill="none"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
        className="benchmark-sparkline-line"
      />
      <circle cx={xFor(pts.length - 1)} cy={yFor(closes[closes.length - 1])} r="2" fill={stroke} vectorEffect="non-scaling-stroke" />
    </svg>
  );
}
